export default __webpack_public_path__ + "static/media/neelam-headshot.67d130b0.jpg";